import { z } from 'zod'

// Timeline identity. `.parse()` strips unknown keys, so these must be declared
// here or the merge silently loses the fields the server sends. `activity_id`
// pairs a start with its completion; `task_id`/`attribution` are the
// association the checkpoint committed, absent on a start because it is emitted
// before that commit runs.
const activityIdentity = {
  activity_id: z.string().nullish(),
  task_id: z.string().nullish(),
  attribution: z.enum(['matched', 'inferred']).nullish(),
}

export function toolSchemas(base) {
  return {
    sseToolSchema: z.object({
      ...base,
      type: z.literal('tool'),
      tool: z.string().optional(),
      label: z.string().optional(),
      arguments: z.unknown().optional(),
      ...activityIdentity,
    }),
    sseToolResultSchema: z.object({
      ...base,
      type: z.literal('tool_result'),
      tool: z.string().optional(),
      label: z.string().optional(),
      status: z.enum(['ok', 'error']).optional(),
      result: z.unknown().optional(),
      payload: z.unknown().optional(),
      ...activityIdentity,
    }),
  }
}
